var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("queryJob.exportOption"),
        width: "400px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            height: "50px",
            "align-items": "center",
            "padding-left": "10px"
          }
        },
        [
          _c(
            "el-checkbox",
            {
              model: {
                value: _vm.isExportOperation,
                callback: function($$v) {
                  _vm.isExportOperation = $$v
                },
                expression: "isExportOperation"
              }
            },
            [_vm._v(_vm._s(_vm.$t("queryJob.exportDescription")))]
          ),
          _c(
            "el-checkbox",
            {
              model: {
                value: _vm.isMergeGroup,
                callback: function($$v) {
                  _vm.isMergeGroup = $$v
                },
                expression: "isMergeGroup"
              }
            },
            [_vm._v(_vm._s(_vm.$t("queryJob.dataNotMerged")))]
          )
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-checkbox",
            {
              staticStyle: { float: "left", margin: "5px 0 0 10px" },
              model: {
                value: _vm.notRemindExportOperation,
                callback: function($$v) {
                  _vm.notRemindExportOperation = $$v
                },
                expression: "notRemindExportOperation"
              }
            },
            [_vm._v(_vm._s(_vm.$t("queryJob.noMoreReminders")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.okHandler } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }